import React from "react";
import { formatterCurrency } from "../../Utils/Utils";

const ProductEcommerceView = ({ productEcom, storeLoc }) => {
  return (
    <div className="px-2">
      {productEcom?.map((item, idx) => {
        const storeLocation = storeLoc.find((store) => store.id === item.id_store);
        return (
          <div className="row my-3">
            <div className="col-md-4">
              <div key={idx}>
                <div className="text-secondary">Brand Name</div>
                <p>{(storeLocation && storeLocation.store_name) || "-"}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div key={idx}>
                <div className="text-secondary">URL</div>
                <p>{(item && item.url) || "-"}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div key={idx}>
                <div className="text-secondary">Price</div>
                <p>{(item && formatterCurrency(item.price)) || "-"}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductEcommerceView;
